<template>
  <div id="footer">
      <div class="footer">
          <img src="../assets/logo.png" alt="Mealtrips Logo">
          <span>You Order, We Deliver</span>
          <b-row>
              <b-col cols="4">
                  <h4>Useful Links</h4>
                  <ul class="navbar-nav">
                      <li class="navbar-item">
                          <a href="#" class="navbar-link">Terms and Conditions</a>
                      </li>
                      <li class="navbar-item">
                          <a href="../privacy.html" class="navbar-link">Privacy Policy</a>
                      </li>
                      <li class="navbar-item">
                          <a href="mailto:mealtrips@gmail.com" class="navbar-link">Sponsorship and Advert</a>
                      </li>
                  </ul>
              </b-col>
              <b-col cols="4">
                  <h4>Our Social Media Pages</h4>
                  <ul class="navbar-nav">
                      <li class="navbar-item">
                          <a href="#" class="navbar-link">Facebook</a>
                      </li>
                      <li class="navbar-item">
                          <a href="#" class="navbar-link">Instagram</a>
                      </li>
                      <li class="navbar-item">
                          <a href="#" class="navbar-link">Twitter</a>
                      </li>
                  </ul>
              </b-col>
              <b-col cols="4">
                  <h4>Stay up-to-date with Us</h4>
                  <p>Subscribe to our Newsletter</p>
                  <form @submit.prevent="sendNewsletter">
                      <div class="form-group">
                          <input type="email" name="email" v-model="email" id="email" placeholder="Enter you email" class="newsletter" required>
                      </div>
                      <button type="submit" class="subscribe">Subscribe</button>
                  </form>
              </b-col>
          </b-row>
      </div>
      <div class="rights">
          <p>2021. All rights reserved. MealTrips</p>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Footer',
    data() {
        return {
            email: ''
        }
    },
    methods: {
        sendNewsletter(e) {
            try{
                axios.post('https://sheetdb.io/api/v1/wbfx8cks1bf54',{
                "data": {"email": this.email}
            }).then( () => {
                alert('Thanks for subscribing')
            });
            } catch(error){
                console.log({error})
            }
            this.email = ''
        }
    }
}
</script>

<style lang="scss" scoped>
#footer{
    .footer{
        background: url('../assets/Footer.png');
        background-size: cover;
        background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: 'Raleway', sans-serif;
        position: relative;
        padding: 80px 0;
        img{
            height: 60px;
            width: 174px;
            margin-bottom: 10px;
        }
        span{
            font-size: 24px;
            font-weight: 300;
            text-align: center;
            margin-bottom: 47px;
        }
        .row{
            width: 100%;
            padding: 0 8%;
            h4{
                font-size: 24px;
                font-weight: 300;
                color: #455A64;
                margin-bottom: 24px;
            }
            a.navbar-link{
                color: #455A64;
                font-weight: 500;
                font-size: 24px;
                margin-bottom: 12px;
                &:hover{
                    text-decoration: none;
                }
            }
            .newsletter{
                width: 100%;
                border-radius: 8px;
                padding: 16px 32px;
                border: 1px solid #2B2D4280;
            }
            .subscribe{
                background: #363636;
                border-radius: 8px;
                border: none;
                color: #fff;
                text-align: center;
                width: 100%;
                padding: 16px 0;
            }
        }
    }
    .rights{
        background: #D4E3ED;
        font-size: 18px;
        font-weight: 300;
        text-align: center;
        padding: 30px 0;
        color: #455A64;
        margin: 0;
        z-index: 1;
    }
}

@media(max-width: 480px) {
    #footer{
    .footer{
        background: url('../assets/Footer.png');
        background-size: cover;
        background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: 'Raleway', sans-serif;
        position: relative;
        padding: 80px 0;
        img{
            height: 40px;
            width: 100px;
            margin-bottom: 10px;
        }
        span{
            font-size: 18px;
            font-weight: 300;
            text-align: center;
            margin-bottom: 47px;
        }
        .row{
            width: 100%;
            padding: 0 8%;
            h4{
                font-size: 18px;
                font-weight: 300;
                color: #455A64;
                margin-bottom: 10px;
            }
            .col-4{
                flex: 0 0 100%;
                max-width: 100%;
                margin-bottom: 28px;
            }
            a.navbar-link{
                color: #455A64;
                font-weight: 500;
                font-size: 18px;
                margin-bottom: 12px;
                &:hover{
                    text-decoration: none;
                }
            }
            .newsletter{
                width: 100%;
                border-radius: 8px;
                padding: 16px 32px;
                border: 1px solid #2B2D4280;
            }
            .subscribe{
                background: #363636;
                border-radius: 8px;
                border: none;
                color: #fff;
                text-align: center;
                width: 100%;
                padding: 16px 0;
            }
        }
    }
    .rights{
        background: #D4E3ED;
        font-size: 18px;
        font-weight: 300;
        text-align: center;
        padding: 30px 0;
        color: #455A64;
        margin: 0;
        z-index: 1;
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
    #footer{
    .footer{
        background: url('../assets/Footer.png');
        background-size: cover;
        background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: 'Raleway', sans-serif;
        position: relative;
        padding: 80px 0;
        img{
            height: 40px;
            width: 100px;
            margin-bottom: 10px;
        }
        span{
            font-size: 18px;
            font-weight: 300;
            text-align: center;
            margin-bottom: 47px;
        }
        .row{
            width: 100%;
            padding: 0 8%;
            h4{
                font-size: 18px;
                font-weight: 300;
                color: #455A64;
                margin-bottom: 10px;
            }
            .col-4{
                flex: 0 0 100%;
                max-width: 100%;
                margin-bottom: 28px;
            }
            a.navbar-link{
                color: #455A64;
                font-weight: 500;
                font-size: 18px;
                margin-bottom: 12px;
                &:hover{
                    text-decoration: none;
                }
            }
            .newsletter{
                width: 100%;
                border-radius: 8px;
                padding: 16px 32px;
                border: 1px solid #2B2D4280;
            }
            .subscribe{
                background: #363636;
                border-radius: 8px;
                border: none;
                color: #fff;
                text-align: center;
                width: 100%;
                padding: 16px 0;
            }
        }
    }
    .rights{
        background: #D4E3ED;
        font-size: 18px;
        font-weight: 300;
        text-align: center;
        padding: 30px 0;
        color: #455A64;
        margin: 0;
        z-index: 1;
    }
}
}
</style>